import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('RewardPreview').create(({ theme }) => ({
  root: {
    width: '100%',
    maxWidth: '128px',
    height: '138px',
    display: 'flex',
    position: 'relative',
    borderRadius: '12px',
    border: '1px solid',
    overflow: 'hidden',
    borderColor: '#313236',

    '&[data-small="true"]': {
      width: '82px',
      height: '82px',
    },

    '&[data-rewardtype="legendary"]': {
      borderColor: theme.colors.borders.legendary,
      boxShadow: `0 0 10px ${theme.colors.borders.legendary}`,
    },
    '&[data-rewardtype="epic"]': {
      borderColor: theme.colors.borders.epic,
      boxShadow: `0 0 10px ${theme.colors.borders.epic}`,
    },
    '&[data-rewardtype="rare"]': {
      borderColor: theme.colors.borders.rare,
      boxShadow: `0 0 10px ${theme.colors.borders.rare}`,
    },
  },

  img: {
    position: 'absolute',
    width: '90%',
    aspectRatio: '1/1',
    top: '5%',
    left: 4,

    '&[data-isclaimed="true"]': {
      opacity: 0.1,
    },

    '&[data-boxname="cargocase"]': {
      width: '100%',
      left: '-2%',
    },
  },

  yearsAndMonths: {
    fontFamily: 'Space Grotesk, Inter',
    fontWeight: 600,
    fontSize: '15px',
    lineHeight: theme.sizes.texts.lineHeight.xl,
    color: theme.colors.text.primary,
    textTransform: 'lowercase',
    marginLeft: '4px',
  },

  contentWrapper: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    height: '100%',
    alignItems: 'flex-end',
    justifyContent: 'center',
    gap: '4px',
    zIndex: 2,
    paddingBottom: '8px',
  },

  amountOfPoints: {
    fontFamily: 'Space Grotesk',
    fontWeight: 700,
    fontSize: '16px',
    textAlign: 'center',
    color: theme.colors.text.primary,
  },

  rewardText: {
    fontFamily: 'Space Grotesk, Inter',
    fontWeight: 500,
    maxWidth: '90%',
    fontSize: theme.sizes.texts.fontSize.xs,
    textAlign: 'center',
    color: theme.colors.text.primary,

    '&[data-rewardtext="Unique Gift"]': {
      fontSize: '15px',
    },

    '&[data-rewardtext="Подарок"]': {
      fontFamily: 'Inter',
      fontSize: '15px',
    },
    '&[data-isclaimed="true"]': {
      opacity: 0.1,
    },
  },

  chance: {
    position: 'absolute',
    color: '#000000',
    fontSize: theme.sizes.texts.fontSize.xs,
    fontWeight: 700,
  },
  chanceLabel: {
    fontSize: '12px',
    position: 'absolute',
    bottom: '-2px',
    left: '0px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    color: theme.colors.text.primary,
    zIndex: 3,

    width: '100%',
  },

  chanceText: {
    fontFamily: 'Space Grotesk',
    fontWeight: 800,
    fontSize: '12px',
    color: 'rgba(29, 30, 34, 1)',
  },

  claimedReward: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: '5',
    opacity: '1!important',
    display: 'none',
    flexDirection: 'column',
    gap: '4px',

    span: {
      fontWeight: 440,
      textAlign: 'center',
      fontSize: '14px',
      lineHeight: theme.sizes.texts.lineHeight.m,
      fontFamily: 'Space Grotesk',
      color: 'rgba(117, 119, 120, 1)',
    },

    '&[data-isclaimed="true"]': {
      display: 'flex',
    },
  },
}))
